import React from 'react';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Grid,
  GridProps,
  FormHelperText,
} from '@mui/material';
import { FORM_STYLES } from '../../../constants';

interface SelectOption {
  value: string;
  label: string;
}

interface FormikSelectProps {
  name: string;
  label: string;
  value: string;
  onChange: (event: any) => void;
  onBlur: (event: any) => void;
  options: SelectOption[];
  error?: string;
  placeholder?: string;
  disabled?: boolean;
  required?: boolean;
  gridProps?: GridProps;
}

const FormikSelect: React.FC<FormikSelectProps> = ({
  name,
  label,
  value,
  onChange,
  onBlur,
  options,
  error,
  placeholder = 'Please select...',
  disabled = false,
  required = false,
  gridProps = { xs: 12, md: 4 },
}) => {
  return (
    <Grid item {...gridProps}>
      <FormControl fullWidth size={FORM_STYLES.FIELD_SIZE} error={!!error}>
        <InputLabel 
          shrink 
          style={FORM_STYLES.LABEL}
          htmlFor={name}
        >
          {label} {required && <sup>*</sup>}
        </InputLabel>
        <Select
          id={name}
          name={name}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          disabled={disabled}
          variant="outlined"
          displayEmpty
          inputProps={{
            style: FORM_STYLES.INPUT,
          }}
        >
          <MenuItem value="" disabled>
            {placeholder}
          </MenuItem>
          {options.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
        {error && <FormHelperText>{error}</FormHelperText>}
      </FormControl>
    </Grid>
  );
};

export default FormikSelect;